import { Box, FormControlLabel, Radio, RadioGroup, TextField, type Theme } from "@mui/material";

import { Text } from "../../components/Text";
import { GeofenceWarningBanner } from "../../DailyView/components/ReportIssueDialog/GeofenceWarningBanner";

export interface WleFormContentProps {
  hasLeftGeofence?: boolean;
  timezone?: string;
  reasonDescription: string;
  permissionGiven: boolean | null | undefined;
  /** Label for the "yes, permission was given" radio. Defaults to generic text. */
  permissionYesLabel?: string;
  /** Label for the "no, permission was not given" radio. Defaults to generic text. */
  permissionNoLabel?: string;
  onReasonDescriptionChange: (value: string) => void;
  onPermissionGivenChange: (value: boolean) => void;
}

/**
 * Shared form content for Worker Left Early (WLE) reporting.
 * Used by both WorkerLeftEarlyModal (legacy) and FcmWleDialog (redesign).
 */
export function WleFormContent(props: WleFormContentProps) {
  const {
    hasLeftGeofence,
    timezone,
    reasonDescription,
    permissionGiven,
    permissionYesLabel = "Yes, and I am okay with this worker leaving early.",
    permissionNoLabel = "No, this worker left without permission.",
    onReasonDescriptionChange,
    onPermissionGivenChange,
  } = props;

  return (
    <Box
      sx={(theme: Theme) => ({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
      })}
    >
      {hasLeftGeofence === false && (
        <GeofenceWarningBanner variant="still-in-building" timezone={timezone} />
      )}

      <Text variant="body2">Why is the worker leaving the shift early?</Text>

      <TextField
        fullWidth
        multiline
        // oxlint-disable-next-line typescript/no-explicit-any
        inputProps={{ "data-testid": "worker-left-early-modal-textbox" } as any}
        placeholder="Please describe the situation"
        rows={4}
        value={reasonDescription}
        onChange={(event) => onReasonDescriptionChange(event.target.value)}
      />

      <Text variant="body2">Did the worker leave with your permission?</Text>
      <RadioGroup
        value={
          permissionGiven === null || permissionGiven === undefined ? "" : String(permissionGiven)
        }
        onChange={(event) => onPermissionGivenChange(event.target.value === "true")}
      >
        <FormControlLabel value="true" control={<Radio />} label={permissionYesLabel} />
        <FormControlLabel value="false" control={<Radio />} label={permissionNoLabel} />
      </RadioGroup>
    </Box>
  );
}
